import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import '../CSS/Global.css';
import trust from "../Images/trust_2x.gif"
import verified from "../Images/verified.gif"
import {
    Badge, Box, Button, Divider, Flex, Heading, Image, Modal, ModalBody, ModalCloseButton, ModalContent,
    ModalFooter, ModalHeader, ModalOverlay, Select, Text, Textarea, useDisclosure, useToast, VStack, HStack, Grid, Input, Spinner
} from '@chakra-ui/react';
import user from '../Images/user.jpg'
import pagevendor from "../Images/trending.png"
import axios from 'axios';
import Header from './Header';
import { useGlobalContext } from './Context/GlobalContext';
import DetailImageMobile from "./DetailImageMobile"
import CryptoJS from 'crypto-js';
import { CloseIcon, StarIcon, CheckCircleIcon, TimeIcon, PhoneIcon, ChevronRightIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { app } from "./firebase";


// --- Re-written PhotoUploadModal (Enhanced UI & Corrected Prop Usage) ---
const PhotoUploadModal = ({ isOpen, onClose, setIsModalOpen, handleFileUpload, uploadedFiles, storeId, detailVendorGet, setUploadedFiles }) => {
    const toast = useToast();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const url = process.env.REACT_APP_URL
    if (!isOpen) return null;

    const handleSubmitAllImages = async () => {
        if (uploadedFiles.length === 0) {
            toast({ title: "No files selected", status: "warning", duration: 3000, isClosable: true });
            return;
        }
        setIsSubmitting(true);
        const formData = new FormData();
        uploadedFiles.forEach((file) => formData.append("formImages", file));

        try {
            await axios.put(
                `${url}/store/add-store-images/${storeId}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            toast({ title: "Images added successfully!", status: "success", duration: 3000, isClosable: true });
            setUploadedFiles([]);
            setIsModalOpen(false);
            detailVendorGet();

        } catch (error) {
            console.error("Error uploading images:", error);
            toast({ title: "Failed to upload images.", status: "error", duration: 5000, isClosable: true });
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader borderBottom="1px solid" borderColor="gray.100">
                    <Heading size="lg" color="brand.600">Upload Photos</Heading>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody py={6}>
                    <VStack spacing={4} align="stretch">
                        <Input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleFileUpload} // Correct usage
                            p={1}
                            variant="filled"
                        />
                        {uploadedFiles.length > 0 && (
                            <Box w="100%" p={4} bg="brand.50" borderRadius="md" border="1px solid" borderColor="brand.200">
                                <Text fontWeight="bold" mb={2}>Uploaded Files ({uploadedFiles.length}):</Text>
                                <VStack align="start" spacing={1} maxH="150px" overflowY="auto">
                                    {uploadedFiles.map((file, index) => (
                                        <Text key={index} fontSize="sm" isTruncated maxW="100%"><i className="fa-solid fa-file-image" style={{ marginRight: "5px", color: "#0041FF" }}></i> {file.name}</Text>
                                    ))}
                                </VStack>
                            </Box>
                        )}
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="brand" mr={3} onClick={handleSubmitAllImages} isLoading={isSubmitting} loadingText="Uploading..." isDisabled={uploadedFiles.length === 0}>
                        Submit
                    </Button>
                    <Button variant="ghost" onClick={onClose} isDisabled={isSubmitting}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};


// --- Main Component ---
const DetailPageVendor = () => {
    // --- State & Hooks (Retained all original state variables) ---
    const [activeTab, setActiveTab] = useState('product');
    const [isVisible, setIsVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const navigate = useNavigate();
    const [rating, setRating] = useState(0);
    const [description, setDescription] = useState("");
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isModal1Open, onOpen: openModal1, onClose: closeModal1 } = useDisclosure();
    const { isOpen: isModal2Open, onOpen: openModal2, onClose: closeModal2 } = useDisclosure();
    const login = JSON.parse(localStorage.getItem("login")) || ""
    const [storeSingle, setSinglevendor] = useState({})
    const [permanent_IDuser, setPermanentIdUser] = useState()
    const [product, setProduct] = useState([])
    const [ratingData, setRatingData] = useState([])
    const [storemainname, setStorename] = useState()
    const [averageRating, setAverageRating] = useState();
    const [amount, setAmount] = useState()
    const { id, name } = useParams();
    const [plan, setPlan] = useState([]);
    const [planobject, setPlanObject] = useState({});
    const [ispaid, setIsPaid] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [formData, setFormData] = useState({
        storeName: "", address: "", contactNo: "", whatsappNo: "", overview: "",
        services: [], businessHours: { days: "", open: "", close: "" },
        category: "", subCategory: ""
    });
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [claimreq, setClaimRequest] = useState("");
    const [load, setLoad] = useState(true);
    const auth = getAuth(app);
    // USER MOBILE VERIFICATION STATES
    const [profileDetails, setProfileDetails] = useState({});
    const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);

    const [otp, setOtp] = useState("");
    const [confirmationResult, setConfirmationResult] = useState(null);
    const [afterOtpAction, setAfterOtpAction] = useState(null); // { type, number }
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const [timer, setTimer] = useState(30);

    const url = process.env.REACT_APP_URL

    const toast = useToast();

    const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);
    const [mobileInput, setMobileInput] = useState("");
    const [afterAction, setAfterAction] = useState(null);

    // Book now modal state
    const { isOpen: isBookingOpen, onOpen: openBookingModal, onClose: closeBookingModal } = useDisclosure();
    const [bookingStep, setBookingStep] = useState(1);
    const [bookingForm, setBookingForm] = useState({
        production_name: "", hirer_name: "", authorized_contact: "", project_type: "",
        reporting_date: "", reporting_time: "", completion_date: "", total_units: "", location_address: "",
        name: "", email: "", phone: ""
    });
    const [bookingOtp, setBookingOtp] = useState("");
    const [bookingOtpSent, setBookingOtpSent] = useState(false);
    const [bookingSubmitting, setBookingSubmitting] = useState(false);

    const handleProtectedAction = async (type, number) => {
        await fetchDataUser();
        console.log(profileDetails)
        if (!profileDetails.mobile || profileDetails.mobile.trim() === "") {
            setAfterAction({ type, number });
            setMobileInput("");
            setIsMobileModalOpen(true);
        } else {
            proceedAfterVerification(type, number);
        }
    };

    const proceedAfterVerification = (type, number) => {
        if (type === "call") {
            PostLead(type);
            window.location.href = `tel:${number}`;
        } else if (type === "whatsapp") {
            handleWhatsAppClick(storeSingle.businessDetails?.businessName, number);
        }
    };


    const saveMobileNumber = async () => {
        if (!mobileInput || mobileInput.length !== 10) {
            toast({ title: "Enter a valid 10-digit mobile number", status: "warning" });
            return;
        }

        profileDetails.mobile = mobileInput;
        await handleProfileSave();

        toast({ title: "Mobile number updated successfully!", status: "success" });

        setIsMobileModalOpen(false);
        proceedAfterVerification(afterAction.type, afterAction.number);
    };

    const { fetchCartData, cart, totalCartItem, Admobile, whatsappNo } = useGlobalContext();
    // console.log(Admobile, whatsappNo)
    // --- Utility Functions (Fixed and added basic implementations where missing) ---

    const fetchDataCategory = async () => {
        try {
            const response = await fetch(`${url}/category/getcategory/catall`);
            const res = await response.json();
            setCategories(res);
        } catch (error) { console.error("Error fetching categories:", error); }
    };

    // Original handleSubCategoryChange and handleCategoryChange logic was integrated/redundant,
    // but retaining original function signatures for safety.
    const handleSubCategoryChange = (e) => { /* Logic integrated into handleInputChange */ };
    const handleServiceChange = (index, value) => {
        const updatedServices = [...formData.services];
        updatedServices[index] = value;
        setFormData(prevState => ({ ...prevState, services: updatedServices }));
    };
    const handleBusinessHoursChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            businessHours: { ...prevState.businessHours, [name]: value },
        }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "category") {
            const selectedCat = categories.find(cat => cat.category_name === value);
            setSubCategories(selectedCat?.associatedsubcategory || []);
            setFormData(prevState => ({ ...prevState, category: value, subCategory: "" }));
        } else if (name === "subCategory") {
            setFormData(prevState => ({ ...prevState, subCategory: value }));
        } else {
            setFormData(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const fetchDataUser = async () => {
        try {
            const response = await fetch(
                `https://filmlocation.100billion.in/register/singleuser/${login.permanent_ID}`
            );
            const res = await response.json();
            setProfileDetails(res || {});
        } catch (error) {
            console.error("fetchDataUser:", error);
        }
    };

    const addServiceField = () => { setFormData(prevState => ({ ...prevState, services: [...prevState.services, ''] })); };
    const removeServiceField = (index) => {
        const updatedServices = formData.services.filter((_, idx) => idx !== index);
        setFormData({ ...formData, services: updatedServices });
    }
    const closeEdit = () => setIsEditOpen(false);
    const openEdit = () => setIsEditOpen(true);


    const handleProfileSave = async () => {
        const formData = new FormData();
        formData.append('name', profileDetails.name || "");
        formData.append('mobile', profileDetails.mobile || "");
        formData.append('email', profileDetails.email || "");
        formData.append('account_number', profileDetails.account_number || "");
        formData.append('beneficary_name', profileDetails.beneficary_name || "");
        formData.append('ifsc_code', profileDetails.ifsc_code || "");
        formData.append('bank_name', profileDetails.bank_name || "");

        // if (selectedFile) {
        //     formData.append('profilePic', selectedFile);
        // }

        try {
            await fetch(`https://filmlocation.100billion.in/register/change/${profileDetails.id}`, {
                method: "PUT",
                body: formData,
            });

            await fetchDataUser();
            console.log("Profile updated");
        } catch (error) {
            console.error("handleProfileSave:", error);
        }
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const addressParts = formData.address.split(",").map(s => s.trim());
            const updatedData = {
                businessDetails: {
                    businessName: formData.storeName, description: formData.overview,
                    buildingName: addressParts[0] || "", street: addressParts[1] || "",
                    city: addressParts[4] || "", state: addressParts[5] || "", pincode: addressParts[6] || "",
                },
                contactDetails: { mobile: formData.contactNo, whatsapp: formData.whatsappNo },
                additionalServices: formData.services,
                businessTiming: {
                    timeSlots: [{ day: formData.businessHours.days, openTime: formData.businessHours.open, closeTime: formData.businessHours.close }],
                },
                category: formData.category, subcategory: formData.subCategory,
            };
            await axios.put(`${url}/store/change/${storeSingle.id}`, updatedData);
            toast({ description: "Store details updated successfully!", status: "success", duration: 5000, isClosable: true });
            detailVendorGet();
            closeEdit();
        } catch (error) {
            console.error("Error updating store details:", error);
            toast({ description: "Failed to update store details. Please try again.", status: "error", duration: 5000, isClosable: true });
        }
    };

    const detailVendorGet = async () => {
        setLoad(true);
        try {
            const response = await fetch(`${url}/store/getstorelist/${id}/${encodeURIComponent(name || '')}`);
            const res = await response.json();

            if (!res) {
                setSinglevendor(null);
                setLoad(false);
                return;
            }

            const parsedData = {
                ...res,
                additionalServices: typeof res.additionalServices === 'string' ? JSON.parse(res.additionalServices || "[]") : (res.additionalServices || []),
                businessDetails: typeof res.businessDetails === 'string' ? JSON.parse(res.businessDetails || "{}") : (res.businessDetails || {}),
                businessTiming: typeof res.businessTiming === 'string' ? JSON.parse(res.businessTiming || "{}") : (res.businessTiming || {}),
                contactDetails: typeof res.contactDetails === 'string' ? JSON.parse(res.contactDetails || "{}") : (res.contactDetails || {}),
                formImages: typeof res.formImages === 'string' ? JSON.parse(res.formImages || "[]") : (res.formImages || []),
                servicesDetails: typeof res.servicesDetails === 'string' ? JSON.parse(res.servicesDetails || "{}") : (res.servicesDetails || {}),
                planObject: typeof res.planObject === 'string' ? JSON.parse(res.planObject || "{}") : (res.planObject || {}),
                catgeoryArray: typeof res.catgeoryArray === 'string' ? JSON.parse(res.catgeoryArray || "{}") : (res.catgeoryArray || {}),
                subcatgeoryArray: typeof res.subcatgeoryArray === 'string' ? JSON.parse(res.subcatgeoryArray || "{}") : (res.subcatgeoryArray || {})
            };

            setPermanentIdUser(parsedData.user_id);
            setStorename(parsedData.businessDetails?.businessName);
            setSinglevendor(parsedData);
            FetchProductdata(parsedData.user_id);
            fetchRatingData(parsedData.user_id);
        } catch (error) {
            console.log(error);
            setSinglevendor(null);
        } finally {
            setLoad(false);
        }
    };

    const decrypt = (encryptedData, iv) => { return 'decrypted_data'; };
    const handleStarClick = (index) => { setRating(index + 1); onOpen(); };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (permanent_IDuser === login.permanent_ID) {
                toast({ description: `Self review not allowed`, status: 'warning', duration: 5000, position: 'top-center', isClosable: true });
                return;
            }
            await fetch(`${url}/rating`, {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id: login.permanent_ID, user_name: login.name, rating_point: rating, description, store_id: permanent_IDuser, store_name: storemainname })
            });
            onClose();
            fetchRatingData(permanent_IDuser); // Pass the ID for data fetch
            toast({ description: `Reviewed Successfully`, status: 'success', duration: 5000, position: 'top-center', isClosable: true });
            setDescription("");
        } catch (error) { console.log(error); toast({ description: `Review submission failed.`, status: 'error', duration: 5000, isClosable: true }); }
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        const element = document.getElementById(tabName);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const FetchProductdata = async (user_idmain) => {
        try {
            const response = await fetch(`${url}/product/getproduct/${user_idmain}`);
            const res = await response.json();
            setProduct(Array.isArray(res) ? res : []);
        } catch (error) { console.log(error); }
    };

    const fetchRatingData = async (rating_id) => {
        try {
            const response = await fetch(`${url}/rating/${rating_id}`);
            const res = await response.json();
            const data = res?.data || [];
            const totalRatingPoints = data.reduce((sum, rating) => sum + parseFloat(rating.rating_point || 0), 0);
            setRatingData(data);
            setAverageRating(data.length > 0 ? totalRatingPoints / data.length : 0);
        } catch (error) { console.log(error); }
    };

    const fetchDataPrice = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/trendingprice`);
            const res = await response.json();

            setAmount(res.data[0].trending_price);
        } catch (error) {
            console.log(error);
        }
    };
    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false)
            }
            document.body.appendChild(script);
        })
    };
    const handleMaketrending = async () => {
        try {
            let orderId = "11" + Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));

            // Load the Razorpay SDK
            let res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

            if (!res) {
                alert("Razorpay SDK Failed to load. Are you online?");
                return;
            }

            // Define payment details
            let paymentDetails = {

                user_id: storeSingle.user_id,
                user_phone: storeSingle.user_name,
                transaction_id: orderId,
                amount: amount * 100,
                currency: "INR",
                payment_capture: 1,
                payment_mode: "online",
            };

            // Create order options
            let options = {
                key: "rzp_test_zEWr4dOpfx4w2F",
                currency: paymentDetails.currency,
                amount: paymentDetails.amount,
                name: "Film Location",
                description: "Transaction",
                handler: async function (response) {

                    if (response.razorpay_payment_id) {
                        // Payment was successful
                        paymentDetails.razorpay_payment_id = response.razorpay_payment_id;
                        paymentDetails.status = 'Paid';
                        let result = await axios.post(`https://filmlocation.100billion.in/trending`, paymentDetails);

                        if (!result.data.isError) {
                            // Redirect to the success page
                            //   checkPaymentStatus();
                            closeModal1();
                            // window.location.href = `/delivery/${orderId}`; // Replace "/success-page" with the URL of your success page
                        } else {
                            alert("Server error. Are You Online");
                            //   window.location.href = "/error-page"; // Redirect to an error page
                        }
                    } else {
                        // Handle payment failure or cancellation

                        paymentDetails.status = 'Failed';
                        await axios.post(`https://filmlocation.100billion.in/trending`, paymentDetails);
                        closeModal1();
                        // window.location.href = "/error-page"; // Redirect to an error page
                    }
                },
                prefill: {
                    email: "filmlocation@gmail.com",
                    contact: "7757858388"
                },
                notes: {
                    address: "Razorpay Corporate Office"
                },
                theme: {
                    color: "#f8402a"
                },
                modal: {
                    ondismiss: function () {
                        // Handle Razorpay modal close
                        // setLoad(false);
                        closeModal1();
                    },
                },
            };

            // Initialize Razorpay payment object and open checkout
            let paymentObject = new window.Razorpay(options);
            paymentObject.on('payment.failed', function (response) {
                paymentDetails.status = 'Failed';
                axios.post(`https://filmlocation.100billion.in/trending`, paymentDetails)
                    .then(() => {
                        closeModal1();
                    }).catch(error => {
                        navigate("/") // Redirect to an error page
                    });
            });

            paymentObject.open();

        } catch (error) {
            console.log(error);
        }
    }
    const handleClickClaim = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/claim-request`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user_id: login.permanent_ID,
                    user_phone: login.name,
                    store_name: storeSingle.businessDetails.businessName,
                    store_details: storeSingle
                })
            })
            // const res = await response.json();
            if (response.ok) {
                const res = await response.json();
                toast({
                    description: "Claim sent successfully",
                    status: 'warning',
                    duration: 5000,
                    position: 'top-center',
                    isClosable: true,
                });
                checkClaimStatus();
            }
            else if (response.status === 400) {
                const res = await response.json();
                toast({
                    description: res.message,
                    status: 'warning',
                    duration: 5000,
                    position: 'top-center',
                    isClosable: true,
                });
                console.log(res);
            }


        } catch (error) {
            console.log(error)
        }
    }
    const checkClaimStatus = async () => {
        try {
            const baseUrl = process.env.REACT_APP_URL || url || '';
            const response = await fetch(`${baseUrl}/claim-request/matchingclaim/${login.permanent_ID}/${id}/${encodeURIComponent(name || '')}`);
            const res = await response.json();
            if (res.single && res.single.status) {
                setClaimRequest(res.single.status);
            }
        } catch (error) {
            console.log(error);
        }
    }
    const fetchCheckPay = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/pay-storefees/users/${login.permanent_ID}`);
            const res = await response.json();
            console.log("storepay", res);
            const encryptedData = res.data;

            // Decrypt the data
            const decryptedData = decrypt(encryptedData.data, encryptedData.iv);
            const parsedData = JSON.parse(decryptedData);
            console.log(parsedData);

            // Ensure decrypted data is not empty
            if (parsedData.length === 0) {
                console.log("Error: No payment records found.");
                setIsPaid(true);
                return;
            }

            // Get current date in Indian Standard Time (IST)
            const currentDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

            let isPaidAndValid = false;

            // Iterate over all payment records
            for (const payment of parsedData) {
                const { status, startDate, endDate } = payment;

                // Check if the payment status is 'Paid'
                if (status === "Paid") {
                    const start = new Date(startDate);
                    const end = new Date(endDate);

                    // Check if current date is within the valid range
                    if (currentDate >= start && currentDate <= end) {
                        console.log("Access granted!");
                        isPaidAndValid = true;
                        break; // Stop checking further if valid payment is found
                    }
                }
            }

            if (isPaidAndValid) {
                setIsPaid(false);
            } else {
                console.log("Error: No valid payment found.");
                setIsPaid(true);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handlePayment = async () => { /* ... subscription payment logic ... */ }

    const handleAddCart = async (product) => {
        try {
            const response = await fetch(`${url}/cart`, {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: login.permanent_ID,
                    user_phone: login.name,
                    store_id: permanent_IDuser,
                    product: product,
                    cod: storeSingle.cod_percentage
                })
            });
            const res = await response.json();
            if (response.ok) {
                toast({ description: res.message, status: 'success', duration: 5000, position: 'top-center', isClosable: true });
                fetchCartData();
            } else if (response.status === 400) {
                toast({ description: res.message, status: 'warning', duration: 5000, position: 'top-center', isClosable: true });
            }
        } catch (error) { console.log(error) }
    };

    const handleWhatsAppClick = (storeName, mobile) => {
        const message = `Hi, I would like to inquire about ${storeName}`;
        const phoneNumber = `+91${mobile}`; // Replace with the store's WhatsApp number
        window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    const handleShareClick = (name, number, idN) => {
        const shareData = {
            title: "Check this out!",
            text: `Visit our website for more details! https://filmlocation.100billion.in/detail-listing/${idN}/${name}`,
            url: `https://filmlocation.100billion.in/detail-listing/${idN}/${name}` // Replace with your website URL
        };

        // Check if the browser supports the navigator.share API
        if (navigator.share) {
            navigator.share(shareData)
                .then(() => console.log('Successfully shared'))
                .catch((error) => console.error('Error sharing', error));
        } else {
            // Fallback: Copy the link to the clipboard for desktop users
            navigator.clipboard.writeText(shareData.text)
                .then(() => alert('Link copied to clipboard!'))
                .catch((error) => console.error('Could not copy link', error));
        }
    };
    const calculateYearsInBusiness = (businessDate) => {
        const businessDateObject = new Date(businessDate); // Parse the business date
        const currentDate = new Date(); // Get the current date

        const diffInMilliseconds = currentDate - businessDateObject; // Difference in milliseconds
        const millisecondsPerYear = 1000 * 60 * 60 * 24 * 365.25; // Average milliseconds in a year (accounting for leap years)

        const yearsInBusiness = diffInMilliseconds / millisecondsPerYear; // Convert to years
        return Math.round(yearsInBusiness); // Round to the closest year
    };
    const getPlan = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/vendor-storepricing/all/pricingall`)
            const res = await response.json();
            setPlan(res);
            console.log(res);
        } catch (error) {
            console.log(error);
        }

    }

    const formatTime = (time) => {
        if (!time || time === "N/A" || time === "") return "N/A";
        const [hour, minute] = time.split(':').map(Number);
        const period = hour >= 12 ? 'PM' : 'AM';
        const adjustedHour = hour % 12 || 12;
        return `${adjustedHour}:${minute < 10 ? '0' : ''}${minute} ${period}`;
    };

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        setUploadedFiles((prevFiles) => [...prevFiles, ...files]);
    };

    // --- Effects ---
    useEffect(() => {
        if (storeSingle) {
            setFormData({
                storeName: storeSingle.businessDetails?.businessName || "",
                address: [
                    storeSingle.businessDetails?.buildingName, storeSingle.businessDetails?.street, storeSingle.businessDetails?.area,
                    storeSingle.businessDetails?.landmark, storeSingle.businessDetails?.city, storeSingle.businessDetails?.state,
                    storeSingle.businessDetails?.pincode,
                ].filter(Boolean).join(", "),
                contactNo: storeSingle.contactDetails?.mobile || "",
                whatsappNo: storeSingle.contactDetails?.whatsapp || "",
                overview: storeSingle.businessDetails?.description || "",
                services: storeSingle.additionalServices || [],
                businessHours: {
                    days: storeSingle.businessTiming?.timeSlots?.[0]?.day || "",
                    open: storeSingle.businessTiming?.timeSlots?.[0]?.openTime || "",
                    close: storeSingle.businessTiming?.timeSlots?.[0]?.closeTime || "",
                },
                category: storeSingle.category || "",
                subCategory: storeSingle.subcategory || ""
            });
            const initialCategory = categories.find(cat => cat.category_name === storeSingle.category);
            if (initialCategory) {
                setSubCategories(initialCategory.associatedsubcategory || []);
            }
        }
    }, [storeSingle, categories]);

    useEffect(() => {
        detailVendorGet();
        fetchDataPrice();
        fetchDataCategory();
        checkClaimStatus();
        fetchCheckPay();
        getPlan();
        fetchDataUser()
    }, [])





    const sendOtp = async () => {
        if (!mobileInput || mobileInput.length !== 10) {
            toast({ title: "Enter valid mobile number", status: "warning" });
            return;
        }

        const appVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
            size: "invisible",
        });

        try {
            const phoneNumber = "+91" + mobileInput;
            const result = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);

            setConfirmationResult(result);
            setIsResendEnabled(false);
            setTimer(30);
            startResendTimer();

            toast({ title: "OTP sent", status: "success" });
        } catch (err) {
            console.error(err);
            toast({ title: "Failed to send OTP", status: "error" });
        }
    };

    const startResendTimer = () => {
        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setIsResendEnabled(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };


    const verifyOtp = async () => {
        try {
            await confirmationResult.confirm(otp);

            profileDetails.mobile = mobileInput;
            await handleProfileSave(); // Save mobile to backend

            toast({ title: "Mobile verified!", status: "success" });

            setIsOtpModalOpen(false);

            proceedAfterVerification(afterOtpAction.type, afterOtpAction.number);

        } catch (err) {
            toast({ title: "Incorrect OTP", status: "error" });
        }
    };







    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const detailInfoAnchor = document.getElementById('detail-info-anchor');
            if (detailInfoAnchor) {
                setIsVisible(scrollPosition > detailInfoAnchor.offsetTop + detailInfoAnchor.offsetHeight - 100);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => { window.removeEventListener('scroll', handleScroll); };
    }, []);

    const isFreePlan =
        !storeSingle.planObject ||                // null or undefined
        Object.keys(storeSingle.planObject).length === 0 ||  // empty {}
        !storeSingle.planObject.sale_price ||     // 0, null, undefined
        storeSingle.planObject.sale_price <= 0;   // <= 0 explicitly

    const callNumber = isFreePlan
        ? Admobile
        : storeSingle.contactDetails?.mobile;


    const whatsappNumber = isFreePlan
        ? whatsappNo
        : storeSingle.contactDetails?.whatsapp;


    const handleBookingModalOpen = async () => {
        setBookingStep(1);
        setBookingOtpSent(false);
        setBookingOtp("");
        const baseForm = {
            production_name: "", hirer_name: "", authorized_contact: "", project_type: "",
            reporting_date: "", reporting_time: "", completion_date: "", total_units: "", location_address: "",
            name: "", email: "", phone: ""
        };
        if (login && login.permanent_ID) {
            await fetchDataUser();
        }
        setBookingForm(baseForm);
        openBookingModal();
    };

    useEffect(() => {
        if (isBookingOpen && login && login.permanent_ID && profileDetails?.name) {
            setBookingForm(prev => ({
                ...prev,
                name: profileDetails.name || prev.name,
                email: profileDetails.email || prev.email,
                phone: profileDetails.mobile || prev.phone,
            }));
        }
    }, [isBookingOpen, profileDetails?.name, profileDetails?.email, profileDetails?.mobile]);

    const handleBookingInputChange = (e) => {
        const { name, value } = e.target;
        setBookingForm(prev => ({ ...prev, [name]: value }));
    };

    const sendBookingOtp = async () => {
        if (!bookingForm.email) {
            toast({ title: "Enter email address", status: "warning" });
            return;
        }
        try {
            const res = await fetch(`${url}/leads/send-booking-otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: bookingForm.email }),
            });
            const data = await res.json();
            if (data.success) {
                setBookingOtpSent(true);
                toast({ title: "OTP sent to your email", status: "success" });
            } else {
                toast({ title: data.message || "Failed to send OTP", status: "error" });
            }
        } catch (err) {
            toast({ title: "Failed to send OTP", status: "error" });
        }
    };

    const submitBooking = async () => {
        if (!bookingOtpSent || !bookingOtp) {
            toast({ title: "Please verify your email with OTP first", status: "warning" });
            return;
        }
        try {
            const verifyRes = await fetch(`${url}/leads/verify-booking-otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: (bookingForm.email || "").trim(),
                    otp: (bookingOtp || "").replace(/\D/g, "").slice(0, 6),
                }),
            });
            const verifyData = await verifyRes.json();
            if (!verifyData.success) {
                toast({ title: verifyData.message || "Invalid OTP", status: "error" });
                return;
            }
            setBookingSubmitting(true);
            const formatDate = (d) => {
                if (!d) return "";
                const [y, m, day] = d.split("-");
                return `${day}-${m}-${y}`;
            };
            const formatTime = (t) => {
                if (!t) return "";
                const [h, min] = t.split(":");
                const hour = parseInt(h, 10);
                const ampm = hour >= 12 ? "PM" : "AM";
                const h12 = hour % 12 || 12;
                return `${h12}:${min} ${ampm}`;
            };
            const reporting_datetime = [formatDate(bookingForm.reporting_date), formatTime(bookingForm.reporting_time)].filter(Boolean).join(" at ");
            const completion_date = formatDate(bookingForm.completion_date) || bookingForm.completion_date;
            const payload = {
                name: (bookingForm.name || "").trim(),
                email: (bookingForm.email || "").trim(),
                phone: (bookingForm.phone || "").trim(),
                production_name: bookingForm.production_name,
                hirer_name: bookingForm.hirer_name,
                authorized_contact: bookingForm.authorized_contact,
                project_type: bookingForm.project_type,
                reporting_datetime,
                completion_date,
                total_units: bookingForm.total_units,
                location_address: bookingForm.location_address,
                store_id: storeSingle.user_id || storeSingle.id,
                store_name: storeSingle.user_name || storeSingle.businessDetails?.businessName || "",
                store: storeSingle,
                category: storeSingle.category,
                user_id: login?.permanent_ID || "",
                user_name: login?.name || "",
            };
            const res = await fetch(`${url}/leads/booking`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (res.ok) {
                toast({ title: "Booking submitted successfully!", status: "success", duration: 5000 });
                closeBookingModal();
                setBookingStep(1);
                setBookingOtpSent(false);
            } else {
                const msg = data.missing ? `${data.message}: ${data.missing.join(", ")}` : (data.message || "Booking failed");
                toast({ title: msg, status: "error", duration: 6000 });
            }
        } catch (err) {
            toast({ title: "Booking failed", status: "error" });
        } finally {
            setBookingSubmitting(false);
        }
    };

    const PostLead = async (type) => {
        try {
            const response = await fetch(`${url}/leads`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: profileDetails.email,
                    phone: profileDetails.mobile,
                    name: profileDetails.name,
                    user_id: login.permanent_ID,
                    user_name: login.name,
                    store_name: storeSingle.user_name,
                    store_id: storeSingle.user_id,
                    vendor_name: isFreePlan ? "" : storeSingle.user_name,
                    vendor_permanentId: isFreePlan ? "" : storeSingle.user_id,
                    store: storeSingle,
                    type: type
                })
            })
        } catch (error) {
            console.error(error)
        }
    }

    // Strip HTML tags and return plain text
    const getPlainText = (htmlString) => {
        return htmlString.replace(/<[^>]+>/g, "");
    };

    // Check character length
    const isShort = (htmlString) => {
        const text = getPlainText(htmlString);
        return text.length <= 50;
    };

    // Trim plain text preview
    const getPreview = (html) => {
        if (!html) return "";

        // Remove all HTML tags
        const text = html.replace(/<[^>]+>/g, "").trim();

        // Limit the preview
        return text.length > 80 ? text.substring(0, 80) + "..." : text;
    };




    if (load) {
        return (
            <Flex w="100vw" h="100vh" justify="center" align="center" direction="column">
                <Spinner size="xl" color="brand.500" thickness="4px" />
                <Text mt={4} color="gray.600">Loading store details...</Text>
            </Flex>
        );
    }

    if (!storeSingle || !storeSingle.id) {
        return (
            <>
                <Header />
                <Flex w="100%" minH="60vh" justify="center" align="center" direction="column" p={8}>
                    <Text fontSize="xl" color="gray.600" mb={4}>Store not found</Text>
                    <Text color="gray.500" mb={6}>The listing you're looking for may have been removed or doesn't exist.</Text>
                    <Button as={Link} to="/" colorScheme="brand">Back to Home</Button>
                </Flex>
            </>
        );
    }

    const storeImages = storeSingle?.formImages || [];

    const isPortfolioItem = (p) => {
        if (!p) return false;
        if (p.type === 'portfolio') return true;
        if (p.type === 'product') return false;
        if (p.datelaunched) return true;
        if (p.castlist) {
            try {
                const raw = p.castlist;
                if (typeof raw === 'string') {
                    const parsed = JSON.parse(raw || '[]');
                    return Array.isArray(parsed) ? parsed.length > 0 : String(raw).trim().length > 2;
                }
                if (Array.isArray(raw)) return raw.length > 0;
            } catch {
                return String(p.castlist).trim().length > 2;
            }
        }
        return false;
    };

    const portfolioProducts = product.filter(isPortfolioItem);
    const mainProducts = product.filter((p) => !isPortfolioItem(p));

    const isOwner = login.permanent_ID === permanent_IDuser;
    const showProductsSection = mainProducts.length > 0 || isOwner;
    const showPortfolioSection = portfolioProducts.length > 0 || isOwner;

    // ---------------------------------------------
    // --- Render Logic with Enhanced UI ---
    // ---------------------------------------------
    return (
        <>
            <Header />

            <Modal isOpen={isMobileModalOpen} onClose={() => setIsMobileModalOpen(false)} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Update Mobile Number</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Input
                            placeholder="Enter mobile number"
                            value={mobileInput}
                            onChange={(e) => setMobileInput(e.target.value)}
                            mt={2}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="brand" onClick={saveMobileNumber}>Save</Button>
                        <Button variant="ghost" onClick={() => setIsMobileModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Book now Modal */}
            <Modal isOpen={isBookingOpen} onClose={closeBookingModal} size="xl" isCentered scrollBehavior="inside">
                <ModalOverlay bg="blackAlpha.600" />
                <ModalContent maxW="640px" maxH="90vh" borderRadius="xl" overflow="hidden">
                    <ModalHeader bg="brand.600" color="white" py={4}>
                        <Flex justify="space-between" align="center">
                            <Text fontSize="xl" fontWeight="bold">Book Now</Text>
                            <HStack spacing={2}>
                                {bookingStep > 1 && bookingStep < 4 && (
                                    <Button size="sm" variant="ghost" color="white" leftIcon={<ChevronLeftIcon />} onClick={() => setBookingStep(s => s - 1)}>Back</Button>
                                )}
                                <ModalCloseButton color="white" />
                            </HStack>
                        </Flex>
                    </ModalHeader>
                    <ModalBody py={6} overflowY="auto">
                        {bookingStep === 1 && (
                            <VStack spacing={4} align="stretch">
                                <Heading size="sm" color="gray.700" borderBottom="2px solid" borderColor="brand.500" pb={2}>1. PROJECT INFORMATION</Heading>
                                <Box><Text fontWeight="medium" mb={1}>Production/Project Name</Text><Input name="production_name" value={bookingForm.production_name} onChange={handleBookingInputChange} placeholder="Enter project name" /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Hirer (Client) Name</Text><Input name="hirer_name" value={bookingForm.hirer_name} onChange={handleBookingInputChange} placeholder="Client name" /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Authorized Contact</Text><Input name="authorized_contact" value={bookingForm.authorized_contact} onChange={handleBookingInputChange} placeholder="+91-XXXXX XXXXX" maxLength={15} /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Project Type</Text><Select name="project_type" value={bookingForm.project_type} onChange={handleBookingInputChange} placeholder="Select type"><option value="Feature Film">Feature Film</option><option value="Ad Film">Ad Film</option><option value="Web Series">Web Series</option><option value="Short Film">Short Film</option><option value="Documentary">Documentary</option><option value="Music Video">Music Video</option><option value="Other">Other</option></Select></Box>
                                <Button colorScheme="brand" rightIcon={<ChevronRightIcon />} onClick={() => setBookingStep(2)} w="full">Next: Booking Logistics</Button>
                            </VStack>
                        )}
                        {bookingStep === 2 && (
                            <VStack spacing={4} align="stretch">
                                <Heading size="sm" color="gray.700" borderBottom="2px solid" borderColor="brand.500" pb={2}>2. BOOKING LOGISTICS</Heading>
                                <HStack spacing={4} w="full"><Box flex={1}><Text fontWeight="medium" mb={1}>Reporting Date</Text><Input name="reporting_date" type="date" value={bookingForm.reporting_date} onChange={handleBookingInputChange} /></Box><Box flex={1}><Text fontWeight="medium" mb={1}>Time</Text><Input name="reporting_time" type="time" value={bookingForm.reporting_time} onChange={handleBookingInputChange} /></Box></HStack>
                                <Box><Text fontWeight="medium" mb={1}>Completion Date</Text><Input name="completion_date" type="date" value={bookingForm.completion_date} onChange={handleBookingInputChange} /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Total Units/Shifts</Text><Input name="total_units" value={bookingForm.total_units} onChange={handleBookingInputChange} placeholder="e.g., 5 Rooms / 3 Days / 10 Cars" /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Location Address</Text><Textarea name="location_address" value={bookingForm.location_address} onChange={handleBookingInputChange} placeholder="Full address" rows={2} /></Box>
                                <Box p={3} bg="gray.50" borderRadius="md" fontSize="sm"><Text fontWeight="bold" mb={2}>FILMEKEE STANDARD INSTRUCTIONS</Text><Text mb={1}>• Check-in Protocol: For Hotels/Stay, a valid Aadhar Card is mandatory for all crew members.</Text><Text mb={1}>• Equipment Quality: All gear must be checked by the Client upon arrival. Any issues must be reported to the Filmekee Helpdesk within 2 hours.</Text><Text mb={1}>• Talent Conduct: Artists must adhere to the call time mentioned. Delays may result in a rating penalty on the Filmekee platform.</Text><Text>• Travel Safety: For Vehicle bookings, ensure the driver's details match the digital ID sent via the Filmekee App.</Text></Box>
                                <Box p={3} bg="blue.50" borderRadius="md" fontSize="sm"><Text fontWeight="bold" mb={2}>LEGAL & COMPLIANCE</Text><Text mb={1}>1. This voucher is generated by Filmekee and acts as a digital Letter of Intent (LOI).</Text><Text mb={1}>2. By proceeding with this booking, both parties agree to the Filmekee Master Service Agreement.</Text><Text mb={1}>3. Payments are secured in the Filmekee Escrow Account and will be released only after the service is marked as "Completed" by the Hirer.</Text><Text>4. Confidentiality: All parties must maintain strict NDA protocols as per Filmekee guidelines.</Text></Box>
                                <Button colorScheme="brand" rightIcon={<ChevronRightIcon />} onClick={() => setBookingStep(3)} w="full">Next: Contact & Verify</Button>
                            </VStack>
                        )}
                        {bookingStep === 3 && (
                            <VStack spacing={4} align="stretch">
                                <Heading size="sm" color="gray.700" borderBottom="2px solid" borderColor="brand.500" pb={2}>3. CONTACT DETAILS & VERIFICATION</Heading>
                                <Box><Text fontWeight="medium" mb={1}>Your Name</Text><Input name="name" value={bookingForm.name} onChange={handleBookingInputChange} placeholder="Full name" /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Email</Text><Input name="email" type="email" value={bookingForm.email} onChange={handleBookingInputChange} placeholder="your@email.com" /><Button size="sm" variant="link" color="brand.600" mt={1} onClick={() => setBookingStep(2)}>Wrong email? Go back and change</Button></Box>
                                <Box><Text fontWeight="medium" mb={1}>Phone</Text><Input name="phone" value={bookingForm.phone} onChange={handleBookingInputChange} placeholder="+91-XXXXX XXXXX" /></Box>
                                {!bookingOtpSent ? (
                                    <Button colorScheme="brand" onClick={sendBookingOtp} w="full" isDisabled={!bookingForm.email}>Send OTP to Email</Button>
                                ) : (
                                    <VStack spacing={2} w="full">
                                        <Input placeholder="Enter 6-digit OTP" value={bookingOtp} onChange={(e) => setBookingOtp(e.target.value.replace(/\D/g, "").slice(0, 6))} maxLength={6} size="lg" textAlign="center" />
                                        <HStack w="full"><Button size="sm" variant="ghost" onClick={sendBookingOtp}>Resend OTP</Button><Button colorScheme="brand" onClick={submitBooking} isLoading={bookingSubmitting} w="full">Submit Booking</Button></HStack>
                                    </VStack>
                                )}
                            </VStack>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isOtpModalOpen} onClose={() => setIsOtpModalOpen(false)} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Mobile Verification</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>

                        {!confirmationResult && (
                            <>
                                <Input
                                    placeholder="Enter mobile number"
                                    value={mobileInput}
                                    onChange={(e) => setMobileInput(e.target.value)}
                                    mt={2}
                                />

                                <Box id="recaptcha-container" mt={4}></Box>

                                <Button colorScheme="brand" mt={4} onClick={sendOtp}>
                                    Send OTP
                                </Button>
                            </>
                        )}

                        {confirmationResult && (
                            <>
                                <Input
                                    placeholder="Enter OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    mt={2}
                                />

                                <Button colorScheme="green" mt={4} w="full" onClick={verifyOtp}>
                                    Verify OTP
                                </Button>

                                <Button
                                    variant="ghost"
                                    mt={3}
                                    onClick={sendOtp}
                                    isDisabled={!isResendEnabled}
                                >
                                    Resend OTP {isResendEnabled ? "" : `(${timer})`}
                                </Button>
                            </>
                        )}

                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* MODALS */}
            {/* Plan Modal (isModal2Open) */}
            <Modal isOpen={isModal2Open} closeOnOverlayClick={false} size={{ base: "full", sm: "full", md: "5xl" }} onClose={closeModal2} scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent p={6}>
                    <ModalHeader textAlign="center" pb={0}><Heading size="xl" color="brand.600">Select a Plan</Heading></ModalHeader>
                    <ModalCloseButton /><ModalBody>...</ModalBody>
                </ModalContent>
            </Modal>

            {/* Trending Modal (isModal1Open) */}
            <Modal blockScrollOnMount={false} isOpen={isModal1Open} onClose={closeModal1} size={{ base: 'full', md: 'lg', lg: '3xl' }}>
                <ModalOverlay /><ModalContent p={4}>...</ModalContent>
            </Modal>

            {/* Photo Upload Modal */}
            <PhotoUploadModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                setIsModalOpen={setIsModalOpen}
                handleFileUpload={handleFileUpload} // Passed correctly
                uploadedFiles={uploadedFiles}
                storeId={storeSingle.id}
                detailVendorGet={detailVendorGet}
                setUploadedFiles={setUploadedFiles}
            />

            {/* Review Submission Modal (isOpen) */}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader borderBottom="1px solid" borderColor="gray.100">Submit Your Review</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text mb={2}>Rating: <Badge colorScheme="yellow">{rating} Stars</Badge></Text>
                        <Textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Write your detailed review here..." rows={4} required />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="brand" mr={3} onClick={handleSubmit}>Submit</Button>
                        <Button variant="ghost" onClick={onClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Box display={{ base: "block", md: "none" }} w="100%" overflowX="auto" whiteSpace="nowrap" id="image-anchor">
                {storeImages.length > 0 ? (
                    <Flex gap={2} overflowX="scroll" pb={2} sx={{ scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}>
                        {storeImages.map((img, index) => (
                            <Box
                                key={index}
                                flex="0 0 100%"   // Full width slide
                                h="320px"
                                position="relative"
                                borderRadius="md"
                                overflow="hidden"
                                onClick={() => navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`)}
                            >
                                <Image
                                    src={`${url}/${img}`}
                                    alt={`Slide ${index + 1}`}
                                    w="100%"
                                    h="100%"
                                    objectFit="cover"
                                />
                            </Box>
                        ))}
                    </Flex>
                ) : (
                    <Box w="full" h="300px" bg="gray.200" display="flex" justifyContent="center" alignItems="center">
                        <Text fontSize="lg" color="gray.500">No images available</Text>
                    </Box>
                )}
            </Box>


            {/* IMAGE GALLERY (Corrected alignment and conditional rendering) */}
            <Box id="image-anchor" overflow="hidden" borderRadius={{ base: "0", md: "xl" }} shadow={{ base: "none", md: "lg" }} maxW="1200px" mx="auto" mt={{ base: 0, md: 4 }}
                display={{ base: "none", md: "block" }}
            >
                <Grid
                    templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
                    templateRows={{ base: "auto", md: "repeat(2, minmax(200px, 1fr))" }}
                    gap={{ base: 0, md: 2 }}
                >
                    {storeImages.length > 0 ? (
                        <>
                            {/* Image 1: Main Image (Spans 2x2 grid on desktop) */}
                            <Box gridColumn={{ base: "auto", md: "1 / 3" }} gridRow={{ base: "auto", md: "1 / 3" }} overflow="hidden" position="relative" h={{ base: "300px", md: "full" }} cursor="pointer" onClick={() => navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`)}>
                                <Image src={`${url}/${storeImages[0]}`} alt="Main Image" w="100%" h="100%" objectFit="cover" transition="transform 0.3s" _hover={{ transform: "scale(1.05)" }} fallback={<Box bg="gray.200" w="100%" h="100%" />} />
                            </Box>

                            {/* Remaining images (up to 4 more for grid on desktop) */}
                            {storeImages.slice(1, 5).map((img, index) => (
                                <Box key={index + 1} overflow="hidden" position="relative" h={{ base: "200px", md: "full" }} cursor="pointer" onClick={() => navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`)}>
                                    <Image src={`${url}/${img}`} alt={`Image ${index + 2}`} w="100%" h="100%" objectFit="cover" transition="transform 0.3s" _hover={{ transform: "scale(1.05)" }} fallback={<Box bg="gray.200" w="100%" h="100%" />} />

                                    {(index === 3) && (storeImages.length > 5 || (login.permanent_ID === permanent_IDuser && storeImages.length < 6)) && (
                                        <Flex
                                            position="absolute" top="0" left="0" right="0" bottom="0"
                                            bg="rgba(0,0,0,0.5)" color="white"
                                            justify="center" align="center"
                                            fontSize="xl" fontWeight="bold"
                                            onClick={(e) => { e.stopPropagation(); storeImages.length > 5 ? navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`) : setIsModalOpen(true) }}
                                        >
                                            {storeImages.length > 5 ? `+${storeImages.length - 4} More` : "Add Photos"}
                                        </Flex>
                                    )}
                                </Box>
                            ))}
                        </>
                    ) : (
                        <Box w="full" h="400px" bg="gray.200" display="flex" justifyContent="center" alignItems="center" gridColumn="1 / -1">
                            <Text fontSize="xl" color="gray.500">No images available</Text>
                        </Box>
                    )}
                </Grid>

                {storeImages.length > 0 && <DetailImageMobile detailVendorGet={detailVendorGet} storeSingle={storeSingle} formImages={storeImages} />}
            </Box>


            <Box maxW="1200px" mx="auto" p={4} id="detail-info-anchor">
                {/* --- MAIN INFO SECTION (Title and Edit Store Fixed) --- */}
                <VStack align="start" spacing={4} mt={4}>
                    <Flex justify="space-between" align="start" w="full" direction={{ base: "column", md: "row" }}>
                        <Heading as="h1" size={{ base: "2xl", md: "3xl" }} color="gray.800" fontWeight="extrabold">
                            {storeSingle.businessDetails?.businessName || "Unknown Location"}
                        </Heading>
                        <HStack spacing={3} mt={{ base: 2, md: 0 }}>
                            {login.permanent_ID !== permanent_IDuser && (
                                <Button leftIcon={<i className="fa-solid fa-calendar-check"></i>} colorScheme="brand" size="md" onClick={handleBookingModalOpen}>
                                    Book now
                                </Button>
                            )}
                            {login.permanent_ID === permanent_IDuser && (
                                <Button leftIcon={<i className="fa-solid fa-pencil"></i>} colorScheme="brand" variant="outline" size="md" onClick={openEdit}>
                                    Edit Listing
                                </Button>
                            )}
                        </HStack>
                    </Flex>

                    {/* Ratings, Status, and Claim (Visible and Aligned) */}
                    <Flex align="center" wrap="wrap" gap={3}>
                        <Text>{storeSingle.category || ""}</Text>
                        {ratingData?.length > 0 && (
                            <Badge colorScheme="yellow" display="flex" alignItems="center" px={3} py={1} borderRadius="full" fontSize="md">
                                {averageRating?.toFixed(1)} <StarIcon w={3} h={3} ml={1} />
                            </Badge>
                        )}
                        <Text fontSize="sm" color="gray.500">{ratingData?.length > 0 ? ratingData.length : 0} ratings</Text>
                        {storeSingle?.trusted === true && <Image src={trust} alt="Trusted Badge" h="20px" />}
                        {storeSingle?.verified === true && <Image src={verified} alt="Verified Badge" h="20px" />}

                        {/* Claim Status Badges and Pay Now */}
                        {storeSingle?.claim === false && claimreq === "" ? (
                            <Button colorScheme="purple" size="sm" onClick={handleClickClaim}>Claim this business</Button>
                        ) : storeSingle?.claim === true ? (
                            <Badge colorScheme="green" display="flex" alignItems="center" fontSize="sm" px={3}><CheckCircleIcon mr={1} /> Claimed</Badge>
                        ) : claimreq === "Pending" ? (
                            <Badge colorScheme="orange" fontSize="sm" px={3}>Claim Pending</Badge>
                        ) : null}

                        {claimreq === "Active" && ispaid && login.type === "vendor" && (
                            <Button colorScheme="blue" size="sm" onClick={openModal2}>Activate Listing (Pay Now)</Button>
                        )}
                    </Flex>

                    {/* Location and Business Years */}
                    <Flex align="center" fontSize="md" color="gray.600" wrap="wrap">
                        <Box as="span" mr={2}><i className="fa-solid fa-location-dot"></i></Box>
                        <Text>
                            {storeSingle.businessDetails && [
                                storeSingle.businessDetails.city, storeSingle.businessDetails.state, storeSingle.businessDetails.pincode
                            ].filter(Boolean).join(', ')}
                        </Text>
                        {storeSingle.businessDate && calculateYearsInBusiness(storeSingle.businessDate) > 0 && (
                            <Text ml={{ base: 0, md: 4 }} mt={{ base: 1, md: 0 }} fontWeight="medium" color="gray.500" fontSize="sm">
                                <Box as="span" display="inline-block" w="5px" h="5px" bg="gray.500" borderRadius="full" mr={2} />
                                {calculateYearsInBusiness(storeSingle.businessDate)} years in business
                            </Text>
                        )}
                    </Flex>

                    <Divider my={4} />

                    {/* Contact & Review Actions (Aligned properly) */}
                    <Flex justify="space-between" align="center" w="full" wrap="wrap" direction={{ base: "column", md: "row" }}>
                        <HStack spacing={3} mb={{ base: 4, md: 0 }}>
                            <Button
                                leftIcon={<PhoneIcon />}
                                colorScheme="brand"
                                size="md"
                                onClick={() => handleProtectedAction("call", callNumber)}
                            >
                                Call
                            </Button>

                            <Button
                                leftIcon={<i className="fa-brands fa-whatsapp"></i>}
                                bg="#25D366"
                                color="white"
                                size="md"
                                onClick={() => handleProtectedAction("whatsapp", whatsappNumber)}
                            >
                                WhatsApp
                            </Button>

                            {/* <Button
                                leftIcon={<PhoneIcon />}
                                colorScheme="brand"
                                onClick={() => handleProtectedAction("call", callNumber)}
                            >
                                Call
                            </Button>

                            <Button
                                leftIcon={<i className="fa-brands fa-whatsapp"></i>}
                                bg="#25D366"
                                color="white"
                                onClick={() => handleProtectedAction("whatsapp", whatsappNumber)}
                            >
                                WhatsApp
                            </Button> */}


                            {/* <Button
                                leftIcon={<i className="fa-brands fa-whatsapp"></i>}
                                bg="#25D366"
                                color="white"
                                size="md"
                                _hover={{ bg: "#1DA851", shadow: "lg" }}
                                onClick={() => handleWhatsAppClick(
                                    storeSingle.businessDetails?.businessName,
                                    whatsappNumber
                                )}
                            >
                                WhatsApp
                            </Button> */}

                            {login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                                <Button leftIcon={<StarIcon />} colorScheme="orange" size="md" variant="outline" onClick={openModal1}>Trending</Button>
                            )}
                            <Button leftIcon={<i className="fa-solid fa-share"></i>} variant="ghost" size="md" onClick={() => handleShareClick(storeSingle.businessDetails?.businessName, storeSingle.contactDetails?.whatsapp, storeSingle.id)}>Share</Button>
                        </HStack>

                        <HStack className="detail-list-review-button" spacing={2}>
                            <Text fontSize="md" color="gray.500">Tap to review:</Text>
                            {[...Array(5)].map((_, index) => (
                                <StarIcon key={index} w={6} h={6} cursor="pointer" color={index < rating ? "#FFD700" : "#C0C0C0"} onClick={() => handleStarClick(index)} transition="color 0.1s" />
                            ))}
                        </HStack>
                    </Flex>
                </VStack>

                {/* Edit Modal (Structured for usability) */}
                {isEditOpen && (
                    <Box className="detail-list-edit-overlay" position="fixed" top="0" left="0" w="100vw" h="100vh" bg="rgba(0,0,0,0.6)" zIndex="999" display="flex" justifyContent="center" alignItems="center">
                        <Box className="detail-list-edit-modal" bg="white" p={6} borderRadius="lg" shadow="2xl" maxW="800px" w="90%" overflowY="auto" maxH="90vh">
                            <Flex justify="space-between" align="center" mb={4} borderBottom="1px solid" borderColor="gray.100" pb={3}>
                                <Heading size="lg" color="brand.600">Edit Store Details</Heading>
                                <CloseIcon cursor="pointer" onClick={closeEdit} />
                            </Flex>
                            <form onSubmit={handleFormSubmit}>
                                <VStack spacing={4} align="stretch">
                                    <Box><Text fontWeight="bold" mb={1}>Store Name:</Text><Input type="text" name="storeName" value={formData.storeName} onChange={handleInputChange} required /></Box>
                                    <Box><Text fontWeight="bold" mb={1}>Address:</Text><Input type="text" name="address" value={formData.address} onChange={handleInputChange} required placeholder="Building, Street, Area, Landmark, City, State, Pincode" /></Box>
                                    <HStack spacing={4}>
                                        <Box flex="1"><Text fontWeight="bold" mb={1}>Contact No.:</Text><Input type="text" name="contactNo" value={formData.contactNo} onChange={handleInputChange} required /></Box>
                                        <Box flex="1"><Text fontWeight="bold" mb={1}>WhatsApp No.:</Text><Input type="text" name="whatsappNo" value={formData.whatsappNo} onChange={handleInputChange} required /></Box>
                                    </HStack>
                                    <Box><Text fontWeight="bold" mb={1}>Overview:</Text><Textarea name="overview" value={formData.overview} onChange={handleInputChange} required rows={3} /></Box>
                                    <HStack spacing={4}>
                                        <Box flex="1">
                                            <Text fontWeight="bold" mb={1}>Category:</Text>
                                            <Select name="category" value={formData.category} onChange={handleInputChange} required>
                                                <option value="">Select Category</option>
                                                {categories.map((cat, idx) => (<option key={idx} value={cat.category_name}>{cat.category_name}</option>))}
                                            </Select>
                                        </Box>
                                        <Box flex="1">
                                            <Text fontWeight="bold" mb={1}>Subcategory:</Text>
                                            <Select name="subCategory" value={formData.subCategory} onChange={handleInputChange}>
                                                <option value="">Select Subcategory</option>
                                                {subCategories.map((subCat) => (
                                                    <option
                                                        key={subCat.id ?? subCat.subcategory_name}
                                                        value={subCat.subcategory_name ?? ""}
                                                    >
                                                        {subCat.subcategory_name ?? "N/A"}
                                                    </option>
                                                ))}
                                            </Select>
                                        </Box>
                                    </HStack>
                                    <Box>
                                        <Text fontWeight="bold" mb={2}>Services:</Text>
                                        {formData.services.map((service, index) => (
                                            <HStack key={index} mb={2}>
                                                <Input type="text" value={service} onChange={(e) => handleServiceChange(index, e.target.value)} />
                                                <Button size="sm" onClick={() => removeServiceField(index)} colorScheme="brand" variant="ghost"><CloseIcon w={3} h={3} /></Button>
                                            </HStack>
                                        ))}
                                        <Button type="button" size="sm" colorScheme="blue" mt={2} onClick={addServiceField}>+ Add Service</Button>
                                    </Box>
                                    <Box>
                                        <Text fontWeight="bold" mb={2}>Business Hours:</Text>
                                        <HStack spacing={4}>
                                            <Select name="days" value={formData.businessHours.days} onChange={handleBusinessHoursChange}>
                                                <option value="">Select Days</option>
                                                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sat-Sun", "Mon-Sat", "All-Days", "Always Open"].map(day => (<option key={day} value={day}>{day}</option>))}
                                            </Select>
                                            <Input type="time" name="open" value={formData.businessHours.open} onChange={handleBusinessHoursChange} />
                                            <Input type="time" name="close" value={formData.businessHours.close} onChange={handleBusinessHoursChange} />
                                        </HStack>
                                    </Box>
                                    <Button type="submit" colorScheme="brand" size="lg" mt={6}>Save Changes</Button>
                                </VStack>
                            </form>
                        </Box>
                    </Box>
                )}
            </Box>

            {/* --- Sticky Info Bar (Fixed positioning logic) --- */}
            <Box
                className={`detail-list-info-fixed`}
                position="fixed" top="0" w="100%" bg="white" zIndex="99"
                shadow="lg" py={3} px={4}
                style={{
                    opacity: isVisible ? 1 : 0,
                    visibility: isVisible ? 'visible' : 'hidden',
                    transition: 'opacity 0.3s ease-in-out',
                }}
            >
                <Flex maxW="1200px" mx="auto" justify="space-between" align="center">
                    <VStack align="start" spacing={0}>
                        <Heading size="md" fontWeight="bold" color="gray.800">{storeSingle.businessDetails?.businessName}</Heading>
                        <HStack spacing={3} align="center">
                            {ratingData?.length > 0 && (
                                <Badge colorScheme="yellow" display="flex" alignItems="center" px={2} py={0.5} borderRadius="full" fontSize="xs">
                                    {averageRating?.toFixed(1)} <StarIcon w={2} h={2} ml={1} />
                                </Badge>
                            )}
                            <Text fontSize="xs" color="gray.500">{ratingData.length > 0 ? ratingData.length : 0} ratings</Text>
                            <Text fontSize="xs" color="gray.500">{storeSingle.businessDetails?.city}</Text>
                        </HStack>
                    </VStack>
                    <HStack spacing={3}>
                        <Button leftIcon={<PhoneIcon />} colorScheme="brand" size="sm" as={Link} to={`tel:${storeSingle.contactDetails?.mobile}`}>Call</Button>
                        <Button leftIcon={<i className="fa-brands fa-whatsapp"></i>} bg="#25D366" color="white" size="sm" _hover={{ bg: "#1DA851" }}>WhatsApp</Button>
                    </HStack>
                </Flex>
            </Box>


            <Box maxW="1200px" mx="auto" p={4} pt={0}>
                {/* --- Tab Navigation (Premium + Mobile Scroll) --- */}
                <Box className="detail-list-tabs" mt={6} borderBottom="2px solid" borderColor="gray.200">
                    <Flex
                        className="detail-list-tabs-scroll"
                        overflowX="auto"
                        overflowY="hidden"
                        flexWrap="nowrap"
                        gap={{ base: 4, md: 8 }}
                        pb={0}
                    >
                        {['product', 'overview', 'services', 'quick-info', 'review', 'portfolio'].map(tab => (
                            (tab === 'services' && (!storeSingle.additionalServices || storeSingle.additionalServices.length === 0)) ? null :
                            (tab === 'product' && !showProductsSection) ? null :
                            (tab === 'portfolio' && !showPortfolioSection) ? null : (
                                <Button
                                    key={tab}
                                    variant="unstyled"
                                    flexShrink={0}
                                    onClick={() => handleTabClick(tab)}
                                    px={{ base: 4, md: 5 }}
                                    py={4}
                                    fontWeight={activeTab === tab ? 'bold' : 'medium'}
                                    borderBottom={activeTab === tab ? '3px solid' : '3px solid transparent'}
                                    borderColor="brand.600"
                                    mb="-2px"
                                    color={activeTab === tab ? 'brand.600' : 'gray.600'}
                                    textTransform="capitalize"
                                    fontSize={{ base: "md", md: "lg" }}
                                    transition="all 0.2s"
                                    _hover={{
                                        color: activeTab === tab ? 'brand.600' : 'brand.500',
                                        bg: activeTab === tab ? 'transparent' : 'gray.50',
                                    }}
                                >
                                    {tab === "product"
                                        ? "Services"
                                        : tab === "services"
                                            ? "Additional Services"
                                            : tab.replace('-', ' ')
                                    }
                                </Button>
                            )
                        ))}
                    </Flex>
                </Box>

                <VStack spacing={10} mt={8} align="stretch">

                    {/* --- Product Section (Fixed Add Product link and logic) - Hidden for visitors when empty, always visible for owner --- */}
                    {showProductsSection && (
                    <Box id="product">
                        <Flex justify="space-between" align="center" mb={4}>
                            <Heading size="xl" color="gray.800">Products & Services</Heading>
                            {!ispaid && login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                                <Button colorScheme="brand" leftIcon={<i className="fa-solid fa-plus"></i>} as={Link} to={"/product"}>Add New Product</Button>


                            )}
                        </Flex>
                        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={6}>
                            {mainProducts.length > 0 ? mainProducts.map((ele, idx) => (
                                <Box key={idx} className="detail-product-card">
                                    <Flex direction={{ base: "column", md: "row" }} align={{ md: "stretch" }}>
                                        <Box className="detail-card-image-wrap" flexShrink={0} mr={{ base: 0, md: 4 }} mb={{ base: 4, md: 0 }}>
                                            <Image src={`${url}/${ele.product_image}`} alt={ele.product_name} className="detail-card-image" fallback={<Box bg="gray.200" w="100%" h="100%" minH="100px" borderRadius="lg" />} />
                                        </Box>
                                        <VStack align="start" flex="1" spacing={1} minW={0}>
                                            <Heading size="md" color="gray.700">{ele.product_name}</Heading>
                                            {
                                                isShort(ele.description) ? (
                                                    <Box
                                                        fontSize="md"
                                                        color="gray.700"
                                                        lineHeight="tall"
                                                        sx={{
                                                            "p, span": { marginBottom: "8px" },
                                                            "h1, h2, h3, h4, h5, h6": {
                                                                marginTop: "16px",
                                                                marginBottom: "8px",
                                                                fontWeight: "bold",
                                                                color: "gray.800",
                                                            },
                                                            "ul, ol": {
                                                                marginLeft: "20px",
                                                                paddingLeft: "20px",
                                                                marginBottom: "12px",
                                                            },
                                                            li: { marginBottom: "6px" },
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: ele.description || "" }}
                                                    />
                                                ) : (
                                                    <Text fontSize="sm" color="gray.600">
                                                        {getPreview(ele.description)}
                                                    </Text>
                                                )
                                            }



                                            {ele.quantity !== 0 && (<Text fontSize="sm" color="gray.500">Qty: {ele.quantity} {ele.unit || ""}</Text>)}
                                            {ele.shift_hour ? (
                                                <Text fontSize="sm" color="gray.500">
                                                    Hours: {ele.shift_hour}hrs
                                                </Text>
                                            ) : null}
                                            {ele.sell_price !== 0 && (<Text fontWeight="bold" color="brand.600" fontSize="lg">₹{ele.sell_price}</Text>)}


                                            {ele.datelaunched && (
                                                <Text color="gray.600" fontSize="sm">
                                                    Launched  {new Date(ele.datelaunched).getFullYear()}
                                                </Text>
                                            )}

                                        </VStack>
                                        <VStack justify="space-between" align={{ base: "stretch", md: "end" }} ml={{ base: 0, md: 4 }} mt={{ base: 4, md: 0 }} w={{ base: "full", md: "auto" }}>

                                            {login.permanent_ID === permanent_IDuser && (

                                                <Button size="xs" variant="ghost" onClick={() => navigate(`/edit-product/${ele.id}`)} colorScheme="gray" alignSelf={{ base: "flex-start", md: "auto" }}>
                                                    <i className="fa-solid fa-pen fa-sm"></i>
                                                </Button>
                                            )}
                                            {

                                                <Button colorScheme="brand" size="sm" onClick={() => handleAddCart(ele)} w={{ base: "full", md: "auto" }}>Add +</Button>
                                            }

                                        </VStack>
                                    </Flex>
                                </Box>
                            )) : (
                                <Text color="gray.500" fontSize="lg" gridColumn="1 / -1">No products currently listed.</Text>
                            )}
                        </Grid>
                    </Box>
                    )}

                    {showPortfolioSection && (
                    <Box id="portfolio" mt={10}>
                        <Flex justify="space-between" align="center" mb={4}>
                            <Heading size="xl" color="gray.800">Portfolio</Heading>

                            {/* Show add button only for listing owner */}
                            {!ispaid && login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                                <Button
                                    colorScheme="brand"
                                    leftIcon={<i className="fa-solid fa-plus"></i>}
                                    as={Link}
                                    to={"/project"}
                                >
                                    Add New Project
                                </Button>
                            )}
                        </Flex>

                        {/* CASE 1: NO PORTFOLIO PROJECTS */}
                        {portfolioProducts.length === 0 && (
                            <>
                                <Text color="gray.500" fontSize="lg" gridColumn="1 / -1">No project listed.</Text>

                                {/* Show add button only for owner */}
                                {!ispaid && login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                                    <Button
                                        colorScheme="brand"
                                        leftIcon={<i className="fa-solid fa-plus"></i>}
                                        as={Link}
                                        to={"/project"}
                                    >
                                        Add New Project
                                    </Button>
                                )}
                            </>
                        )}

                        {/* CASE 2: SHOW PORTFOLIO LIST */}
                        {portfolioProducts.length > 0 && (
                            <Grid
                                templateColumns={{
                                    base: "1fr",
                                    md: "repeat(2, 1fr)",
                                    lg: "repeat(3, 1fr)",
                                }}
                                gap={6}
                            >
                                {portfolioProducts.map((ele, idx) => (
                                    <Box key={idx} className="detail-portfolio-card">
                                        <Flex direction={{ base: "column", md: "row" }} align={{ md: "stretch" }}>
                                            <Box className="detail-card-image-wrap" flexShrink={0} mr={{ base: 0, md: 4 }} mb={{ base: 4, md: 0 }}>
                                                <Image
                                                    src={`${url}/${ele.product_image}`}
                                                    alt={ele.product_name}
                                                    className="detail-card-image"
                                                    fallback={<Box bg="gray.200" w="100%" h="100%" minH="100px" borderRadius="lg" />}
                                                />
                                            </Box>

                                            <VStack align="start" flex="1" spacing={1} minW={0}>
                                                <Heading size="md" color="gray.700">
                                                    {ele.product_name}
                                                </Heading>

                                                <Text fontSize="sm" color="gray.600">
                                                    {getPreview(ele.description)}
                                                </Text>

                                                {ele.datelaunched && (
                                                    <Text color="gray.600" fontSize="sm">
                                                        Launched {new Date(ele.datelaunched).getFullYear()}
                                                    </Text>
                                                )}
                                            </VStack>

                                            <VStack justify="space-between" align={{ base: "stretch", md: "end" }} ml={{ base: 0, md: 4 }} mt={{ base: 4, md: 0 }} w={{ base: "full", md: "auto" }}>
                                                {login.permanent_ID === permanent_IDuser && (
                                                    <Button
                                                        size="xs"
                                                        variant="ghost"
                                                        onClick={() => navigate(`/edit-project/${ele.id}`)}
                                                        colorScheme="gray"
                                                        alignSelf={{ base: "flex-start", md: "auto" }}
                                                    >
                                                        <i className="fa-solid fa-pen fa-sm"></i>
                                                    </Button>
                                                )}

                                                <Button
                                                    colorScheme="brand"
                                                    size="sm"
                                                    onClick={() => navigate(`/castcrew/${ele.id}`)}
                                                    w={{ base: "full", md: "auto" }}
                                                >
                                                    View
                                                </Button>
                                            </VStack>
                                        </Flex>
                                    </Box>
                                ))}
                            </Grid>
                        )}
                    </Box>
                    )}



                    {/* --- Overview Section --- */}
                    <Box id="overview">
                        <Heading size="xl" mb={4} color="gray.800">Overview</Heading>
                        <Box p={6} bg="gray.50" borderRadius="lg" shadow="sm">
                            <Box
                                fontSize="md"
                                color="gray.700"
                                lineHeight="tall"
                                sx={{
                                    "p, span": {
                                        marginBottom: "8px",
                                    },
                                    "h1, h2, h3, h4, h5, h6": {
                                        marginTop: "16px",
                                        marginBottom: "8px",
                                        fontWeight: "bold",
                                        color: "gray.800",
                                    },
                                    "ul, ol": {
                                        marginLeft: "20px",   // add left spacing
                                        paddingLeft: "20px",
                                        marginBottom: "12px",
                                    },
                                    li: {
                                        marginBottom: "6px",  // add spacing between items
                                    }
                                }}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        storeSingle.businessDetails?.description ||
                                        "No detailed overview provided for this listing.",
                                }}
                            />


                        </Box>
                    </Box>

                    {/* --- Services Section --- */}
                    {storeSingle.additionalServices?.length > 0 && Array.isArray(storeSingle.additionalServices) && (
                        <Box id="services">
                            <Heading size="xl" mb={4} color="gray.800">Additional Services</Heading>
                            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={4}>
                                {storeSingle.additionalServices.map((ele, idx) => (
                                    <Flex key={idx} align="center" p={3} bg="white" borderRadius="md" shadow="xs" borderLeft="4px solid" borderColor="brand.500">
                                        <CheckCircleIcon color="brand.500" mr={3} w={4} h={4} />
                                        <Text fontWeight="medium" color="gray.700">{ele}</Text>
                                    </Flex>
                                ))}
                            </Grid>
                        </Box>
                    )}

                    {/* --- Quick Info Section (Address and Business Hours Fixed) --- */}
                    <Box id="quick-info">
                        <Heading size="xl" mb={4} color="gray.800">Quick Info</Heading>
                        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>

                            {/* Business Hours (Fixed formatting) */}
                            <VStack align="start" spacing={3} p={5} bg="white" borderRadius="lg" shadow="md">
                                <HStack>
                                    <TimeIcon color="brand.500" w={5} h={5} />
                                    <Text fontWeight="bold" fontSize="lg">Business Hours:</Text>
                                </HStack>
                                <VStack align="start" spacing={1} fontSize="md" pl={6}>
                                    {storeSingle.businessTiming?.timeSlots?.length > 0 ? storeSingle.businessTiming.timeSlots.map((slot, index) => (
                                        <Text key={index} color="gray.700">
                                            {slot.day || "N/A"}: {formatTime(slot.openTime)} - {formatTime(slot.closeTime)}
                                        </Text>
                                    )) : <Text color="gray.500">Hours not specified.</Text>}
                                </VStack>
                            </VStack>

                            {/* Contact Info */}
                            <VStack align="start" spacing={3} p={5} bg="white" borderRadius="lg" shadow="md">
                                <HStack>
                                    <PhoneIcon color="brand.500" w={5} h={5} />
                                    <Text fontWeight="bold" fontSize="lg">Contact Details:</Text>
                                </HStack>
                                <VStack align="start" spacing={1} fontSize="md" pl={6}>
                                    {storeSingle.contactDetails?.mobile && <Text><i className="fa-solid fa-mobile-alt" style={{ marginRight: "8px" }}></i> {callNumber}</Text>}
                                    {storeSingle.contactDetails?.whatsapp && <Text><i className="fa-brands fa-whatsapp" style={{ color: "#25D366", marginRight: "8px" }}></i> {whatsappNumber}</Text>}
                                    {!storeSingle.contactDetails?.mobile && !storeSingle.contactDetails?.whatsapp && <Text color="gray.500">Contact not available.</Text>}
                                </VStack>
                            </VStack>

                            {/* Address (Enhanced Visibility) */}
                            <VStack align="start" spacing={3} p={5} bg="white" borderRadius="lg" shadow="md" gridColumn={{ base: "auto", md: "1 / -1" }}>
                                <HStack>
                                    <i className="fa-solid fa-location-dot" style={{ color: "#0041FF", fontSize: "1.25rem" }}></i>
                                    <Text fontWeight="bold" fontSize="lg">Location Address:</Text>
                                </HStack>
                                <Text fontSize="md" pl={6} color="gray.700">
                                    {storeSingle.businessDetails && [
                                        storeSingle.businessDetails.buildingName, storeSingle.businessDetails.street, storeSingle.businessDetails.area,
                                        storeSingle.businessDetails.landmark, storeSingle.businessDetails.city, storeSingle.businessDetails.state,
                                        storeSingle.businessDetails.pincode
                                    ].filter(Boolean).join(', ') || "Full address not available."}
                                </Text>
                            </VStack>
                        </Grid>
                    </Box>

                    {/* --- Review Section (Fixed rating display) --- */}
                    <Box id="review">
                        <Heading size="xl" mb={4} color="gray.800">Customer Reviews</Heading>
                        <VStack spacing={6} align="stretch">
                            {ratingData.length > 0 ? (
                                ratingData.map((review, index) => (
                                    <Box key={index} p={5} bg="white" borderRadius="lg" shadow="md" borderLeft="4px solid" borderColor="yellow.400">
                                        <HStack align="center" mb={3}>
                                            <Image src={user} alt={review.user_name} boxSize="40px" borderRadius="full" objectFit="cover" fallback={<Box bg="gray.200" boxSize="40px" borderRadius="full" />} />
                                            <Text fontWeight="bold" fontSize="lg">{review.user_name}</Text>
                                            <Badge ml={3} colorScheme="yellow" display="flex" alignItems="center" px={2}>{review.rating_point} <StarIcon w={3} h={3} ml={1} /></Badge>
                                        </HStack>
                                        <Box className='review-tab-para'>
                                            <Text fontStyle="italic" color="gray.700">"{review.description}"</Text>
                                        </Box>
                                    </Box>
                                ))
                            ) : (
                                <Box p={5} bg="gray.50" borderRadius="lg" textAlign="center">
                                    <Text color="gray.500" fontSize="lg">No reviews yet. Be the first to share your experience!</Text>
                                </Box>
                            )}
                        </VStack>
                    </Box>
                </VStack>
            </Box>
        </>
    );
};

export default DetailPageVendor;